import {
  jb_radio_css_default
} from "./chunk.7YWJ7OAP.js";
import {
  l
} from "./chunk.VGR3SD7Z.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  FormElement
} from "./chunk.TQSPBGH7.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n,
  r,
  r2
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-radio/jb-radio.ts
var JbRadio = class extends Initiable(FormElement(i)) {
  constructor() {
    super(...arguments);
    this._focusIndex = 0;
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    if (changedProperties.has("value") || changedProperties.has("options")) {
      const options = this.options ?? [];
      const selectedIndex = options.findIndex((option) => option.value === this.value);
      if (selectedIndex >= 0) {
        this._focusIndex = selectedIndex;
      } else if (this._focusIndex >= options.length) {
        this._focusIndex = 0;
      }
    }
  }
  _handleInputChange(e2) {
    this.value = e2.target.value;
  }
  _handleKeyDown(e2) {
    if (e2.altKey || e2.ctrlKey || e2.metaKey) {
      return;
    }
    const input = e2.currentTarget;
    const isRtl = getComputedStyle(this).direction === "rtl";
    switch (e2.key) {
      case "Enter":
        e2.preventDefault();
        input.click();
        break;
      case "ArrowUp":
      case "ArrowLeft":
        e2.preventDefault();
        this._moveFocus(input, e2.key === "ArrowLeft" && isRtl ? 1 : -1);
        break;
      case "ArrowDown":
      case "ArrowRight":
        e2.preventDefault();
        this._moveFocus(input, e2.key === "ArrowRight" && isRtl ? -1 : 1);
        break;
      case "Backspace":
      case "Delete":
        if (!this.requiredText && this.value) {
          e2.preventDefault();
          this.value = "";
        }
        break;
      default:
        break;
    }
  }
  // Moves only the focus, the option is selected by Space or Enter.
  _moveFocus(from, step) {
    const inputs = Array.from(this._inputs).filter((input) => !input.disabled);
    if (!inputs.length) {
      return;
    }
    const current = inputs.indexOf(from);
    inputs[(current + step + inputs.length) % inputs.length].focus();
  }
  render() {
    const hasError = !!this.errorText || this.showError;
    const errorId = `${this.name}_error`;
    const labelId = `${this.name}_label`;
    return b`
      <div
        class="${e({ error: hasError, disabled: !!this.disabled })}"
        data-fly-tweak="10,-10,20,0"
      >
        ${this.label ? b`<span
                class="main"
                id="${labelId}"
                >${this.label}${this.requiredText ? "*" : ""}</span
              >` : A}
        <div
          class="radios"
          role="radiogroup"
          aria-labelledby=${this.label ? labelId : A}
          aria-invalid="${hasError ? "true" : "false"}"
          aria-describedby=${hasError ? errorId : A}
          aria-required=${!!this.requiredText}
          aria-disabled=${this.disabled ? "true" : A}
        >
          ${(this.options ?? []).map(
      (option, index) => b`
              <label>
                <input
                  type="radio"
                  name="${this.name}"
                  .value=${option.value}
                  .checked=${l(option.value === this.value)}
                  tabindex="${this._focusIndex === index ? "0" : "-1"}"
                  ?required=${!!this.requiredText}
                  ?disabled=${this.disabled}
                  @change=${this._handleInputChange}
                  @focus=${() => {
        this._focusIndex = index;
      }}
                  @keydown=${this._handleKeyDown}
                />
                <span>${option.label}</span>
              </label>
            `
    )}
        </div>
        <div
          id="${errorId}"
          aria-live="polite"
        >
          ${this.showError ? b`<p class="error">${this.requiredText}</p>` : A}
          ${this.errorText ? b`<p class="error">${this.errorText}</p>` : A}
        </div>
      </div>
    `;
  }
};
JbRadio.styles = [reset_css_default, jb_radio_css_default];
JbRadio.shadowRootOptions = { ...i.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Array })
], JbRadio.prototype, "options", 2);
__decorateClass([
  r()
], JbRadio.prototype, "_focusIndex", 2);
__decorateClass([
  r2("input")
], JbRadio.prototype, "_inputs", 2);
JbRadio = __decorateClass([
  customElement("jb-radio")
], JbRadio);

export {
  JbRadio
};
